import { AutoCompleteDataModel, AutoCompleteSuggestions } from 'components/MprcAutoComplete';
import { IAutoCompleteProps, MprcAutoComplete } from 'components/MprcAutoComplete/AutoComplete';
import { MprcRequestSnackbarErrorReport } from 'components/MprcRequestErrorReport';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////

interface IProps extends Omit<IAutoCompleteProps, 'onGetSuggestions'> {
  hasAllReason?: boolean;
}

export const ALL_REASONS_ID = "ALL";

////////////////////////////////////////////////////////////////////////////

export const UserBlockReasonAutoComplete: React.FC<IProps> = ({ label, onChange, hasAllReason, ...props }) => {

  const api = useCoreApi();
  const { t } = useTranslation();

  const [items, setItems] = useState<AutoCompleteDataModel[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  // Ao carregar um DTO:
  useEffect(() => {
    async function getData() {
      try {
        var response = await api.v1.selectors.loginBlockReasons();

        var allReasons = hasAllReason ? [{ key: ALL_REASONS_ID, label: t("shared:AdvFilter.Picker.UserBlockReason.AllBlockReasonText"), canDelete: true }] : [];

        setItems([
          ...allReasons,
          ...response.data.map(x => ({
            key: x.blockReasonId,
            label: x.name,
            canDelete: true,
          }))
        ]);
      }
      catch (e) {
        MprcRequestSnackbarErrorReport(e);
      }
      finally {
        setLoading(false);
      }
    }

    if (loading) getData();
  }, [loading]);

  ////////////////////////////////////////////////////////////////////////////

  ///
  const getSuggestions = (searchText: string, pageNumber: number, pageSize: number): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
    searchText = searchText.toLowerCase();
    return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
      const filterItems = searchText.length > 0
        ? items.filter(opt => opt.label.toLowerCase().includes(searchText))
        : [...items];

      resolve({
        items: filterItems,
        totalRows: filterItems.length
      });
    });
  };

  ////////////////////////////////////////////////////////////////////////////
  /// RENDER
  ////////////////////////////////////////////////////////////////////////////

  return (
    <MprcAutoComplete
      {...props}
      label={label}
      disabled={loading}
      onGetSuggestions={getSuggestions}
      onChange={items => onChange(items as AutoCompleteDataModel[])}
    />
  );
};